// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"29":"chunk_admin-permissions","78":"chunk_admin-wfs-search-channel","245":"chunk_admin-users","623":"chunk_file-layerlist","682":"chunk_admin","857":"chunk_admin-layereditor","893":"chunk_admin-announcements","974":"chunk_admin-layeranalytics"}[chunkId] || chunkId) + "/oskari.min.js";
};